<template>
  <div id="certify">
	<div class="swiper-containers">
		<div class="swiper-wrapper">
			<div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
				<img :src="item.titleImg" :style="{'margin-top':marginTopAndBottom+'px','margin-bottom':marginTopAndBottom+'px'}" />
                <el-divider></el-divider>
                <template v-if="item.title">
                    <p class="title-info swiper-title">
                        <i class="icon iconfont icon-yuandianzhong"></i>
                        {{item.title}}
                    </p>
                    <p class="title-info swiper-info" v-for="(itemp,pindex) in item.infoList" :key="pindex">
                        <i class="icon iconfont icon-yuandianzhong"></i><span>{{itemp}}</span>
                    </p>
                </template>

                <template v-else>
                    <p class="title-info" v-for="(itemp,pindex) in item.infoList" :key="pindex">
                        <i class="icon iconfont icon-yuandianzhong"></i><span>{{itemp}}</span>
                    </p>
                </template>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import Swiper from "swiper";
import 'swiper/swiper.min.css'; 
export default {
    props: {
        swiperList:{
            type:Array,
            default: function(){
                return []
            }
        },
        marginTopAndBottom:{
            type: Number,
            default: 0
        }
    },
    data(){
        return {
            certifySwipers:{}
        }
    },
    methods:{        
        getSwipers(){
            this.certifySwipers = new Swiper('.swiper-containers', {
                watchSlidesProgress: true,
                slideToClickedSlide:true,
                slidesPerView: 'auto',
                centeredSlides: true,
                loop: true,
                loopedSlides: 10,
                autoplay: true,
                on: {
                    progress: function(progress) {
                        for (let i = 0; i < this.slides.length; i++) {
                            var slide = this.slides.eq(i);
                            var slideProgress = this.slides[i].progress;//做左边为0  最右边为1，
                            let modify = 1;
                            if (Math.abs(slideProgress) > 1) {
                                modify = (Math.abs(slideProgress) - 1) * 0.02 +0.97;
                            }                            
                            let translate = slideProgress * modify * 70 + 'px';
                            let scale = 1 - Math.abs(slideProgress) / 10;
                            let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                            slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                            slide.css('zIndex', zIndex);
                            slide.css('opacity', 1);
                            if (Math.abs(slideProgress) > 3) {
                                slide.css('opacity', 0);
                            }
                        }
                    },
                    setTransition: function(swiper, transition) {
                        for (var i = 0; i < this.slides.length; i++) {
                            var slide = this.slides.eq(i)
                            slide.transition(transition);
                        }

                    }
                }
            });
        }
    },
    mounted(){
        this.$nextTick(function () {
            this.getSwipers();            
        })
    }
}
</script>

<style scoped>
    #certify {
        position: relative;
        width: 1200px;
        margin: 0 auto;
        margin-top: 45px;
        overflow: hidden;
    }

    #certify .swiper-containers {
        padding-bottom: 60px;
    }
    
    #certify  .swiper-slide {
        width: 242px;
        height: 300px;
        background: #fff;
        box-shadow: 0 8px 30px #ddd;
        border-radius: 10px;
    }
    #certify  .swiper-slide img{
        width: 100%;
        display:block;
    }
    #certify  .swiper-slide .title-info{
        line-height: 1.5;
        padding-top: 0;
        padding:0 20px;
        color: #333333;
        font-size: 14px;
        margin: 0;
        display: flex;
        
    }
    #certify  .swiper-slide .title-info.swiper-title{
        font-weight: 700;
        font-size: 14px;
        color: #333333;
    }
    
    .title-info .icon{
        color: #fbb113;
        font-size: 12px;
        line-height: 24px;
    }
    .title-info.swiper-info .icon{
        color: #fff;
    }
    .el-divider--horizontal{
        width: 80%;
        margin: 14px auto;
        margin-top: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/brand/AdvantagesSwiper.vue